import * as React from 'react';
import { deprecatedComponent } from '../react/components/core/deprecated-component.js';

function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
/**
 * @deprecated
 * use <Icon iconType="" /> instead
 **/ const IconDelete = deprecatedComponent({
    displayName: 'IconDelete',
    // @ts-ignore
    root: (props)=>/*#__PURE__*/ React.createElement("svg", _object_spread({
            viewBox: "0 0 20 20",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            width: "1em",
            height: "1em"
        }, props), /*#__PURE__*/ React.createElement("path", {
            d: "M5.11234 19.4297L4.36692 19.5125C4.40913 19.8924 4.73017 20.1797 5.11233 20.1797L5.11234 19.4297ZM15.841 19.4297L15.841 20.1797C16.2232 20.1797 16.5443 19.8924 16.5865 19.5126L15.841 19.4297ZM2.57881 3.41949L4.36692 19.5125L5.85775 19.3469L4.06963 3.25385L2.57881 3.41949ZM5.11233 20.1797L15.841 20.1797L15.841 18.6797L5.11234 18.6797L5.11233 20.1797ZM16.5865 19.5126L18.3746 3.41949L16.8838 3.25385L15.0956 19.3469L16.5865 19.5126Z",
            fill: "black"
        }), /*#__PURE__*/ React.createElement("line", {
            x1: 2.28906,
            y1: 3.48169,
            x2: 18.6702,
            y2: 3.48169,
            stroke: "black",
            strokeWidth: 1.5,
            strokeLinecap: "round"
        }), /*#__PURE__*/ React.createElement("path", {
            d: "M6.96289 6.96118L7.68346 15.8162",
            stroke: "black",
            strokeWidth: 1.5,
            strokeLinecap: "round",
            strokeLinejoin: "round"
        }), /*#__PURE__*/ React.createElement("path", {
            d: "M13.2578 15.8162L13.9784 6.96118",
            stroke: "black",
            strokeWidth: 1.5,
            strokeLinecap: "round",
            strokeLinejoin: "round"
        }), /*#__PURE__*/ React.createElement("path", {
            d: "M10.4785 6.94092V15.8417",
            stroke: "black",
            strokeWidth: 1.5,
            strokeLinecap: "round"
        }), /*#__PURE__*/ React.createElement("path", {
            d: "M7.46484 3.25249V1.51328C7.46484 0.992494 7.88702 0.570312 8.40781 0.570312H12.7803C13.3011 0.570312 13.7233 0.992493 13.7233 1.51328V3.25249",
            stroke: "black",
            strokeWidth: 1.5,
            strokeLinecap: "square"
        })),
    description: 'The Inline SVG Icon API is deprecated, use the Icon component instead'
});

export { IconDelete };
